@let control = $control();
@if (control.touched) {
  @for (key of keys(control.errors || []); track key) {
    <kendo-formerror>
      {{ errorMessage(key, control.errors![key]!) }}
    </kendo-formerror>
  }
}
